<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Table of Contents</h2>
<p class="toc-chap"><a href="#/xhtml/fm02">Foreword</a></p>
<p class="toc-chap"><a href="#/xhtml/chap01"><em class="italic">Chapter 1</em>: Autism Spectrum Disorders and Allergies</a></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample"><em class="italic">Chapter 2</em>: Where to Start</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample"><em class="italic">Chapter 3</em>: Diet and Nutrition</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><em class="italic">Chapter 4</em>: Lifestyle</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><em class="italic">Chapter 5</em>: Clearing the Body from Toxins</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample"><em class="italic">Chapter 6</em>: Conclusion</span></p>
<p class="toc-chap"><span href="#/xhtml/bm01" title="Link target outside of Sample">Testimonials</span></p>
<p class="toc-chap"><span href="#/xhtml/bm02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-chap"><span href="#/xhtml/bm03" title="Link target outside of Sample">About the Author</span></p>
<p class="toc-chap"><span href="#/xhtml/bm04" title="Link target outside of Sample">Thank You</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?17faaafb